import { render, staticRenderFns } from "./StatsCampaignsTab.vue?vue&type=template&id=44f596f1&scoped=true&"
import script from "./StatsCampaignsTab.vue?vue&type=script&lang=js&"
export * from "./StatsCampaignsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f596f1",
  null
  
)

export default component.exports